var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitterColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E9ABE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8484 18.8787L28.7724 10.8301H27.1316L21.1195 17.8186L16.3177 10.8301H10.7793L18.0406 21.3979L10.7793 29.8381H12.4202L18.7691 22.458L23.8402 29.8381H29.3786L21.848 18.8787H21.8484ZM19.601 21.491L18.8653 20.4387L13.0114 12.0653H15.5316L20.2558 18.8229L20.9915 19.8752L27.1324 28.659H24.6121L19.601 21.4914V21.491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitterColor);
export default __webpack_public_path__ + "static/media/icon-twitter-color.3e1b31d816792a88e6470c15fa8dafbd.svg";
export { ForwardRef as ReactComponent };